import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Button, Col, Divider, Row, Space } from "antd";
// import { Button } from "components/elements";
import { Input, InputNumber, Select, Switch } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
  LEAVE_GROUP_TYPE,
  REQUEST_CONDITION_TYPE,
} from "../schemas/leaveTypeSchema";
import styles from "../styles/Attendance.module.css";
import { useEffect, useMemo } from "react";



const LeaveNAllowOnlyForm = ({ values = {}, type }) => {
  const { t } = useTranslation();
  return (
    <>
      <Col span={12}>
        <InputNumber
          disabled={type == 'view'}
          name="advanceAtLeast"
          label={t('overtime_condition.label.advance_atLeast')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          textAlign="left"
          precision={0}
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_advance_atLeast")}
        </p>
      </Col>
      <Col span={12}>
        <Switch name="emergencyLeave" label={t('enable-emergency-leave')} disabled={type == 'view'} />
      </Col>
      <Col span={12}></Col>
      {values.emergencyLeave ? (
        <>
          <Col span={12}>
            <InputNumber
              disabled={type == 'view'}
              name="annualLeaveLimit"
              label={t('annual-leave-limit')}
              placeholder={t('0-times')}
              size="large"
              controls={false}
              textAlign="left"
              precision={0}
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
      <Col span={12}>
        <Switch name="halfDayLeave" label={t('half-day-leave')} disabled={type == 'view'} />
      </Col>
      <Col span={12}></Col>
      <Col span={12}>
        <Switch name="consecutiveLimit" label={t('consecutive-leave-limit')} disabled={type == 'view'} />
      </Col>
      <Col span={12}></Col>
      {values.consecutiveLimit ? (
        <>
          <Col span={12}>
            <InputNumber
              disabled={type == 'view'}
              name="maximumConsecutiveLeave"
              label={t('maximum-of-consecutive-leave')}
              placeholder={t('0-days')}
              size="large"
              controls={false}
              textAlign="left"
              precision={0}
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const LeaveNAllowBackdateForm = ({ values = {}, type }) => {
  const { t } = useTranslation();
  return (
    <>
      <Col span={12} >
        <InputNumber
          textAlign="left"
          disabled={type == 'view'}
          name="backDateWithin"
          label={t('working_condition.label.backdate_within')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          step={1}
          min={0}
          precision={0}
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_backdate_within")}
        </p>
      </Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="emergencyLeave" label={t('enable-emergency-leave')} />
      </Col>
      <Col span={12}></Col>
      {values.emergencyLeave ? (
        <>
          <Col span={12}>
            <InputNumber
              disabled={type == 'view'}
              name="annualLeaveLimit"
              label={t('annual-leave-limit')}
              placeholder={t('0-times')}
              size="large"
              controls={false}
              precision={0}
              textAlign="left"
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
      <Col span={12}>
        <Switch disabled={type == 'view'} name="halfDayLeave" label={t('half-day-leave')} />
      </Col>
      <Col span={12}></Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="consecutiveLimit" label={t('consecutive-leave-limit')} />
      </Col>
      <Col span={12}></Col>
      {values.consecutiveLimit ? (
        <>
          <Col span={12}>
            <InputNumber
              disabled={type == 'view'}
              name="maximumConsecutiveLeave"
              label={t('maximum-of-consecutive-leave')}
              placeholder={t('0-days')}
              size="large"
              controls={false}
              textAlign="left"
              precision={0}
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const LeaveNAllowAdvanceNBackdate = ({ values = {}, type }) => {
  const { t } = useTranslation();
  return (
    <>
      <Col span={12}></Col>
      <Col span={12}>
        <InputNumber
          disabled={type == 'view'}
          name="advanceAtLeast"
          label={t('overtime_condition.label.advance_atLeast')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          textAlign="left"
          precision={0}
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_advance_atLeast")}
        </p>
      </Col>

      <Col span={12} >
        <InputNumber
          textAlign="left"
          disabled={type == 'view'}
          name="backDateWithin"
          label={t('working_condition.label.backdate_within')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          step={1}
          min={0}
          precision={0}
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_backdate_within")}
        </p>
      </Col>
      <Col span={12}>
        <Switch name="emergencyLeave" label={t('enable-emergency-leave')} />
      </Col>
      <Col span={12}></Col>
      {values.emergencyLeave ? (
        <>
          <Col span={12}>
            <InputNumber
              disabled={type == 'view'}
              name="annualLeaveLimit"
              label={t('annual-leave-limit')}
              placeholder={t('0-times')}
              size="large"
              controls={false}
              precision={0}
              textAlign="left"
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
      <Col span={12}>
        <Switch disabled={type == 'view'} name="halfDayLeave" label={t('half-day-leave')} />
      </Col>
      <Col span={12}></Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="consecutiveLimit" label={t('consecutive-leave-limit')} />
      </Col>
      <Col span={12}></Col>
      {values.consecutiveLimit ? (
        <>
          <Col span={12}>
            <InputNumber
              name="maximumConsecutiveLeave"
              label={t('maximum-of-consecutive-leave')}
              placeholder={t('0-days')}
              size="large"
              controls={false}
              textAlign="left"
              precision={0}
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

// --------------
const OffsiteNAllowOnlyForm = ({ values = {}, type }) => {
  const { t } = useTranslation()
  return (
    <>
      <Col span={12}>
        <InputNumber
          disabled={type == 'view'}
          name="advanceAtLeast"
          label={t('overtime_condition.label.advance_atLeast')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          precision={0}
          textAlign="left"
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_advance_atLeast")}
        </p>
      </Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="emergencyLeave" label={t('enable-emergency-leave')} />
      </Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="consecutiveLimit" label={t('consecutive-leave-limit')} />
      </Col>
      {values.emergencyLeave ? (
        <Col span={12}>
          <InputNumber
            disabled={type == 'view'}
            name="annualLeaveLimit"
            label={t('annual-leave-limit')}
            placeholder={t('0-times')}
            size="large"
            controls={false}
            precision={0}
            textAlign="left"
          />
        </Col>
      ) : (
        <Col span={12}></Col>
      )}
      {values.consecutiveLimit ? (
        <Col span={12}>
          <InputNumber
            disabled={type == 'view'}
            name="maximumConsecutiveLeave"
            label={t('maximum-of-consecutive-leave')}
            placeholder={t('0-days')}
            size="large"
            controls={false}
            textAlign="left"
            precision={0}
          />
        </Col>
      ) : (
        <Col span={12}></Col>
      )}
    </>
  );
};

const OffsiteNAllowBackdateForm = ({ values = {}, type }) => {
  const { t } = useTranslation()
  return (
    <>
      <Col span={12}>
        <InputNumber
          disabled={type == 'view'}
          name="backDateWithin"
          label={t('working_condition.label.backdate_within')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          textAlign="left"
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_backdate_within")}
        </p>
      </Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="emergencyLeave" label={t('enable-emergency-leave')} />
      </Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="consecutiveLimit" label={t('consecutive-leave-limit')} />
      </Col>
      {values.emergencyLeave ? (
        <Col span={12}>
          <InputNumber
            disabled={type == 'view'}
            name="annualLeaveLimit"
            label={t('annual-leave-limit')}
            placeholder={t('0-times')}
            size="large"
            controls={false}
            precision={0}
            textAlign="left"
          />
        </Col>
      ) : (
        <Col span={12}></Col>
      )}
      {values.consecutiveLimit ? (
        <Col span={12}>
          <InputNumber
            disabled={type == 'view'}
            name="maximumConsecutiveLeave"
            label={t('maximum-of-consecutive-leave')}
            placeholder={t('0-days')}
            size="large"
            controls={false}
            textAlign="left"
            precision={0}
          />
        </Col>
      ) : (
        <Col span={12}></Col>
      )}
    </>
  );
};

const OffsiteNAllowAdvanceNBackdate = ({ values = {}, type }) => {
  const { t } = useTranslation();
  return (
    <>
      <Col span={12}></Col>
      <Col span={12}>
        <InputNumber
          disabled={type == 'view'}
          name="advanceAtLeast"
          label={t('overtime_condition.label.advance_atLeast')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          textAlign="left"
          precision={0}
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_advance_atLeast")}
        </p>
      </Col>
      <Col span={12} >
        <InputNumber
          textAlign="left"
          disabled={type == 'view'}
          name="backDateWithin"
          label={t('working_condition.label.backdate_within')}
          placeholder={t('unlimited-leave-days')}
          size="large"
          controls={false}
          step={1}
          min={0}
          precision={0}
        />
        <p style={{ color: "#98A2B3" }}>
          {t("description.Supported_backdate_within")}
        </p>
      </Col>
      <Col span={12}>
        <Switch name="emergencyLeave" label={t('enable-emergency-leave')} />
      </Col>
      <Col span={12}></Col>
      {values.emergencyLeave ? (
        <>
          <Col span={12}>
            <InputNumber
              disabled={type == 'view'}
              name="annualLeaveLimit"
              label={t('annual-leave-limit')}
              placeholder={t('0-times')}
              size="large"
              controls={false}
              precision={0}
              textAlign="left"
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
      <Col span={12}>
        <Switch disabled={type == 'view'} name="halfDayLeave" label={t('half-day-leave')} />
      </Col>
      <Col span={12}></Col>
      <Col span={12}>
        <Switch disabled={type == 'view'} name="consecutiveLimit" label={t('consecutive-leave-limit')} />
      </Col>
      <Col span={12}></Col>
      {values.consecutiveLimit ? (
        <>
          <Col span={12}>
            <InputNumber
              name="maximumConsecutiveLeave"
              label={t('maximum-of-consecutive-leave')}
              placeholder={t('0-days')}
              size="large"
              controls={false}
              textAlign="left"
              precision={0}
            />
          </Col>
          <Col span={12}></Col>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

const LeaveRequestForm = ({
  values = {},
  leaveRequestConditionOptions = [],
  minimumLeaveGroupOptions = [],
  documentLimitGroupOptions = [],
  setFieldValue = () => { },
  type
}) => {


  const { t } = useTranslation();
  const getRequestForm = (type) => {


    if (!values.leaveGroupCode || !values.requestConditionCode) {
      return <></>;
    }
    if (values.leaveGroupCode === LEAVE_GROUP_TYPE.LEAVE) {

      if (values.requestConditionCode === REQUEST_CONDITION_TYPE.ADVANCE_ONLY) {
        return <LeaveNAllowOnlyForm values={values} type={type} />;
      }
      if (values.requestConditionCode === REQUEST_CONDITION_TYPE.ALLOW_BACKDATE) {
        return <LeaveNAllowBackdateForm values={values} type={type} />;
      }
      if (
        values.requestConditionCode ===
        REQUEST_CONDITION_TYPE.ALLOW_ADVANCE_AND_BACKDATE
      ) {
        return <LeaveNAllowAdvanceNBackdate values={values} type={type} />;
      }
    }

    // 
    if (values.leaveGroupCode === LEAVE_GROUP_TYPE.OFFSITE_MEETING) {
      if (values.requestConditionCode === REQUEST_CONDITION_TYPE.ADVANCE_ONLY) {
        return <OffsiteNAllowOnlyForm values={values} type={type} />;
      }
      if (values.requestConditionCode === REQUEST_CONDITION_TYPE.ALLOW_BACKDATE) {
        return <OffsiteNAllowBackdateForm values={values} type={type} />;
      }
      if (
        values.requestConditionCode ===
        REQUEST_CONDITION_TYPE.ALLOW_ADVANCE_AND_BACKDATE
      ) {
        return <OffsiteNAllowAdvanceNBackdate values={values} type={type} />;
      }
    }
  };

  return (
    <>
      <Row justify="space-between" style={{ paddingTop: "24px" }}>
        <b className={styles.infoTopic}>{t('leave-request')}</b>
      </Row>
      <Divider />
      <Row gutter={[24, 16]}>
        <Col span={12}>
          <Select
            required
            disabled={type == 'view'}
            name="minimumLeave"
            label={t('minimum-leave-required-1')}
            placeholder={t('please-select-1')}
            size="large"
            options={minimumLeaveGroupOptions}
          />
        </Col>
        <Col span={12}>
          <Select
            required
            disabled={type == 'view'}
            name="docLimitPerDay"
            label={t('new_document_limit_per_day')}
            placeholder={t('please-select-1')}
            size="large"
            options={documentLimitGroupOptions}
          />
        </Col>
        <Col span={12}>
          <Select
            required
            disabled={type == 'view'}
            name="requestConditionId"
            label={t('new_request_condition')}
            placeholder={t('please-select-1')}
            size="large"
            options={leaveRequestConditionOptions}
            onChange={(_, opt) => {
              if (opt) {
                setFieldValue("requestCondition", opt.nameEn);
                setFieldValue("requestConditionCode", opt.code);
              }
            }}
          />
        </Col>
        {getRequestForm(type)}
      </Row>
    </>
  );
};

const LeaveConditionForm = ({
  values = {},
  setFieldValue,
  genderOptions = [],
  leaveCalculationOptions = [],
  monthWeekDayWorkingOptions = [],
  type,
  modifiedWorkInLocationOption = []
}) => {
  const { t } = useTranslation();
  // const mockWorkinLocation = [

  //   {
  //     workInLocationId: '1',
  //     workInLocationName: 'test 001'
  //   },
  //   {
  //     workInLocationId: '2',
  //     workInLocationName: 'test 002'
  //   },
  //   {
  //     workInLocationId: '6',
  //     workInLocationName: 'test 006'
  //   },
  // ]

  // const modifiedWorkInLocationOption = useMemo(() => {
  //   return mockWorkinLocation?.map((o) => ({
  //     value: o?.workInLocationId,
  //     label: o?.workInLocationName
  //   }))
  // }, [mockWorkinLocation])
  const getConditionForm = () => {
    // ชนิดคำขอลาหยุด
    if (values.leaveGroupCode === LEAVE_GROUP_TYPE.LEAVE) {
      return (
        <>
          {/* ผ่านทดลองงาน */}
          <Col span={12}>
            <Switch
              disabled={type == 'view'}
              name="permanentOnly"
              label={t('overtime_condition.label.permanent_employees_only')}
              checked={values.permanentOnly}
              onChange={(checked) => {
                setFieldValue('permanentOnly', checked);
                setFieldValue('includeProbation', !checked); // ทำให้ includeProbation เป็นค่าตรงข้าม
              }} />
          </Col>
          {/* นับวันหยุดเป็นวันลา */}
          <Col span={12}>
            <Switch disabled={type == 'view'} name="countHolidays" label={t('count-holidays-as-leave-days')} />
          </Col>
          {/* นับตั้งเเต่วันเริ่มงาน */}
          <Col span={12}>
            <Switch
              disabled={type == 'view'}
              name="includeProbation"
              label={t('include-probation-period')}
              checked={values.includeProbation}
              onChange={(checked) => {
                setFieldValue('includeProbation', checked);
                setFieldValue('permanentOnly', !checked); // ทำให้ permanentOnly เป็นค่าตรงข้าม
              }} />
          </Col>
          {/* ไม่ได้รับค่าจ้าง */}
          <Col span={12}>
            <Switch disabled={type == 'view'} name="leaveWithoutPay" label={t('leave-without-pay')} />
          </Col>
          {/* ต้องแนบไฟล์ */}
          <Col span={12} >
            <Switch disabled={type == 'view'} name="attachment" label={t('attachment-required')} />
            {values.attachment ? (
              <Row style={{ marginTop: "16px" }}>
                <Col span={24}>
                  <InputNumber
                    disabled={type == 'view'}
                    name="whenLeavingSince"
                    label={t('when-leaving-since')}
                    placeholder={t('0-days')}
                    size="large"
                    controls={false}
                    textAlign="left"
                    precision={0}
                  />
                </Col>
              </Row>
            ) : null}
          </Col>
          {/* ลาได้ครั้งเดียว */}
          <Col span={12}>
            <Switch disabled={type == 'view'} name="allowOnce" label={t('allow-once')} />
          </Col>
          {/* ใช้ได้เฉพาะในเดือนเกิด */}
          <Col span={12}>
            <Switch disabled={type == 'view'} name="avalibleInBirth" label={t('available-only-in-the-birth-month')} />
          </Col>
          {/* สะสมข้ามปี */}
          <Col span={12}>
            <Switch
              disabled={type == 'view'}
              name="accumulatedAnnualLeave"
              label={t('accumulated-annual-leave')}
              onChange={(checked) => {
                if (!checked) {
                  setFieldValue('maxLeaveAccum', null);
                  setFieldValue('maxLeaveAccumLastYear', null);
                  setFieldValue('expiringMonth', null);
                }
              }}
            />
          </Col>
          {values.accumulatedAnnualLeave ? (
            <>
              <Col span={12}>
                <InputNumber
                  required
                  disabled={type == 'view'}
                  name="maxLeaveAccum"
                  label={t('maximum-leave-accumulation')}
                  placeholder={t('0-days')}
                  size="large"
                  controls={false}
                  textAlign="left"
                  precision={0}
                />
              </Col>
              <Col span={12}>
                <InputNumber
                  required
                  disabled={type == 'view'}
                  name="maxLeaveAccumLastYear"
                  label={t('maximum-leave-accumulated-from-last-year')}
                  placeholder={t('0-days')}
                  size="large"
                  controls={false}
                  textAlign="left"
                  precision={0}
                />
              </Col>
              <Col span={12}>
                <Select
                  required
                  disabled={type == 'view'}
                  name="expiringMonth"
                  label={t('expiring-month')}
                  placeholder={t('please-select-1')}
                  size="large"
                  options={monthWeekDayWorkingOptions}
                />
              </Col>
              <Col span={12}></Col>
              {/* <Col span={12}>
            <Switch disabled={values.isView} name="extraAllowance" label={t('extra-allowance')} />
            </Col> */}
              {/* <Col span={12}>
              <Switch disabled={values.isView} name="diligenceAllowance" label={t('diligence-allowance')} />
            </Col> */}
            </>
          ) : (
            <></>
          )}

          <Col span={12}>
            <Select
              disabled={type == 'view'}
              name="gender"
              label={t('employee.gender')}
              placeholder={t('please-select-1')}
              size="large"
              options={genderOptions}
            />
          </Col>
          <Col span={12}>
            <Select
              disabled={type == 'view'}
              name="leaveCalculation"
              label={t('calculation-of-rights')}
              placeholder={t('please-select-1')}
              size="large"
              options={leaveCalculationOptions}
            />
          </Col>
        </>
      );
    }

    // ชนิดคำขอปฏิบัติงานนอกสถานที่
    if (values.leaveGroupCode === LEAVE_GROUP_TYPE.OFFSITE_MEETING) {
      return (
        <>
          <Col span={12}>
            <Switch disabled={type == 'view'} name="permanentOnly" label={t('overtime_condition.label.permanent_employees_only')} />
          </Col>
          <Col span={12}>
            <Switch disabled={type == 'view'} name="countHolidays" label={t('count-holidays-as-leave-days')} />
          </Col>
          <Col span={12}>
            <Switch disabled={type == 'view'} name="attachment" label={t('attachment-required')} />
            {values.attachment ? (
              <Row style={{ marginTop: "16px" }}>
                <Col span={24}>
                  <InputNumber
                    disabled={type == 'view'}
                    name="whenLeavingSince"
                    label={t('when-leaving-since')}
                    placeholder={t('0-days')}
                    size="large"
                    controls={false}
                    precision={0}
                    textAlign="left"
                  />
                </Col>
              </Row>
            ) : null}
          </Col>
          <Col span={12}>
            <Switch disabled={type == 'view'} name="allowOnce" label={t('allow-once')} />
          </Col>
          {/* <Col span={12}>
            <Switch disabled={values.isView} name="diligenceAllowance" label={t('diligence-allowance')} />
          </Col> */}
          <Col span={12}>
            <Select
              disabled={type == 'view'}
              name="gender"
              label={t('gender')}
              placeholder={t('common.pleaseSelect')}
              size="large"
              options={genderOptions}
            />
          </Col>
          <Col span={12}>
            <Select
              name="workInLocationListId"
              placeholder={t('please-select-1')}
              size="large"
              label={
                t("workin_location.entity")
              }
              mode="multiple"
              options={modifiedWorkInLocationOption}
              disabled={type == 'view' || values?.initialFlag === 'Y'}
              // disabled={
              //   currentWorkingLocation.workInLocationId
              //     ? true
              //     : false
              // }
              onChange={(val) => {
                // console.log("test values ", val);

                // 
                // setFieldValue("workInLocationListId", device);
              }}
              required
            /></Col>
        </>
      );
    }
  };

  return (
    <>
      <Row justify="space-between" style={{ paddingTop: "24px" }}>
        <b className={styles.infoTopic}>{t('leave-condition')}</b>
      </Row>
      <Divider />
      <Row gutter={[24, 16]}>{getConditionForm()}</Row>
    </>
  );
};

function LeaveTypeForm({
  initialValues = {},
  genderOptions = [],
  leaveGroupOptions = [],
  leaveCalculationOptions = [],
  monthWeekDayWorkingOptions = [],
  leaveRequestConditionOptions = [],
  minimumLeaveGroupOptions = [],
  documentLimitGroupOptions = [],
  onCancel = () => { },
  onSubmit = () => { },
  type,
  modifiedWorkInLocationOption = []
}) {
  const { t } = useTranslation();
  // console.log("initialValues ", initialValues?.workInLocationListId?.map((o) => {
  //   o?.workInLocationId
  // }));

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES, ...initialValues, workInLocationListId: initialValues?.workInLocationListId?.map((o) => o?.workInLocationId)
      }}
      onSubmit={onSubmit}
      validationSchema={schema}
      validate={(values) => {
        const errors = {}
        if (values.accumulatedAnnualLeave) {
          if (!values.maxLeaveAccum) {
            errors.maxLeaveAccum = 'Required'
          }
          if (!values.maxLeaveAccumLastYear) {
            errors.maxLeaveAccumLastYear = 'Required'
          }
          if (!values.expiringMonth) {
            errors.expiringMonth = 'Required'
          }
        }
        return errors
      }}
    >
      {(formikProps) => {
        const { values = {}, setFieldValue = () => { } } = formikProps;
        return (
          <Form>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <div className="card">
                <Row justify="space-between">
                  <b className={styles.infoTopic}>
                    {type === 'view'
                      ? t("leave_type.header")
                      : initialValues.id
                        ? t("common.edit")
                        : t("common.create")
                    }
                  </b>
                </Row>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <Input
                      required
                      disabled={type == 'view'}
                      name="leaveTypeName"
                      label={t("leave_type.label.leave_type_name_th")}
                      placeholder={t('leave_type.label.leave-type-name-th')}
                      size="large"
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      required
                      disabled={type == 'view'}
                      name="leaveTypeNameEn"
                      label={t("leave_type.label.leave_type_name_en")}
                      placeholder={t('leave_type.label.leave-type-name-en')}
                      size="large"
                    />
                  </Col>
                  <Col span={12}>
                    <Select
                      required
                      disabled={type == 'view' || values?.initialFlag === 'Y'}
                      name="leaveGroupId"
                      label={t("leave_type.label.leave_category")}
                      placeholder={t('please-select-1')}
                      size="large"
                      options={leaveGroupOptions}
                      onChange={(_, opt) => {
                        if (opt) {
                          setFieldValue("leaveGroupName", opt.nameEn);
                          setFieldValue("leaveGroupCode", opt.code);
                        }
                      }}
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      required
                      disabled={type == 'view'}
                      name="description"
                      label={t("leave_type.label.description")}
                      placeholder={t('expense.lable.description')}
                      size="large"
                    />
                  </Col>
                </Row>
                {values.leaveGroupId ? (
                  <LeaveRequestForm
                    {...formikProps}
                    leaveRequestConditionOptions={leaveRequestConditionOptions}
                    minimumLeaveGroupOptions={minimumLeaveGroupOptions}
                    documentLimitGroupOptions={documentLimitGroupOptions}
                    type={type}
                  />
                ) : (
                  <></>
                )}
                {values.leaveGroupId && values.requestConditionId ? (
                  <LeaveConditionForm
                    {...formikProps}
                    modifiedWorkInLocationOption={modifiedWorkInLocationOption}
                    genderOptions={genderOptions}
                    monthWeekDayWorkingOptions={monthWeekDayWorkingOptions}
                    leaveCalculationOptions={leaveCalculationOptions}
                    type={type}
                  />
                ) : (
                  <></>
                )}


                <Row justify="end" style={{ paddingTop: "24px" }}>
                  <Space size={12}>
                    <Button type="default" onClick={onCancel} style={{ borderRadius: "8px", height: "40px" }}>
                      {t(type == 'view' ? "common.confirm" : "common.cancel").toUpperCase()}
                    </Button>
                    {type !== 'view' ? <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)" }}>
                      {t("common.submit").toUpperCase()}
                    </Button> : null}
                  </Space>
                </Row>
              </div>
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
}

export default LeaveTypeForm;
